import { PDD_OMS_BASE_URL } from "@/config";
import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import AuthTokenHolder, { TOKEN_KEY } from "../AuthTokenHolder";
import { uuid } from "@/utils";

/** @see https://app.apifox.com/project/4298530/apis/api-260391566 */
export async function getPageCodeRequestUrl(shops: ShopDTO[]) {
    const search = new URLSearchParams();

    search.set("reqId", uuid());

    const pddShopIds = [];
    /** 理论上店铺群下pdd供应商是只会有1个的 */
    let pddSupplierShopId = null;
    for (const shop of shops) {
        if ([ShopType.PINDUODUO, ShopType.PDD_FDS, ShopType.PDD_FULFILLMENT].includes(shop.type)) {
            pddShopIds.push(shop.id);
        } else if ([ShopType.PDD_DROP_SHIPPING_SUPPLIER].includes(shop.type)) {
            pddSupplierShopId = shop.id;
        }
    }

    if (pddShopIds?.length) {
        const pddShopIdsStr = pddShopIds.join();
        search.set("pddShopIds", pddShopIdsStr);
    }

    if (pddSupplierShopId) {
        search.set("pddSupplierShopId", pddSupplierShopId);
    }

    return "/pdd/security/page_code" + "?" + search.toString();
}

export function getAxios() {
    const TIMEOUT = 20000;

    const pddAxios = axios.create({
        baseURL: PDD_OMS_BASE_URL,
        timeout: TIMEOUT,
        withCredentials: true,
    });

    pddAxios.interceptors.request.use((config: AxiosRequestConfig) => {
        const token = AuthTokenHolder.getToken();

        if (token) {
            config.headers[TOKEN_KEY] = token;
        }

        return config;
    });

    pddAxios.interceptors.response.use(undefined, (error) => {
        const response = error?.response as AxiosResponse;

        const statusCode = response?.status;

        switch (statusCode) {
            // 权限校验失败状态
            case 401:
            case 403:
                AuthTokenHolder.clearToken();
        }

        return Promise.reject(error);
    });

    return pddAxios;
}
